module.exports = "/work-site/img/banner-1.00e4a4a3.png";